module.exports = __webpack_public_path__ + "static/media/lady-shutterbug.de59210f.jpg";